import { render, staticRenderFns } from "./GreenPanel.vue?vue&type=template&id=0b4b69a6&"
import script from "./GreenPanel.vue?vue&type=script&lang=ts&"
export * from "./GreenPanel.vue?vue&type=script&lang=ts&"
import style0 from "./GreenPanel.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports